import React from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import {useSuiContext} from '@s-ui/react-context'
import {useMediaQuery} from '@s-ui/react-hooks'
import {useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'
import {TrackingWithEventTrack} from '@adv-mt/mt-tracking-with-event-track-hoc'

import ModalWithUrlState from './modal-with-url-state.js'
import NavigationLastAdsSearchesContent from './navigation-last-ads-searches-content.js'

const MODAL_HASH = 'lastAdsSearches'
const MODAL_CLOSE_CLASS = ''
const TRACKS = [{event: 'Recent Searches Popup'}]
const BASE_CLASS = 'mt-NavigationLastAdsSearches'

const NavigationLastAdsSearchesModal = ({isOpen, onClose, onOpen, lastAdsSearches}) => {
  const {i18n, domain} = useSuiContext()

  const config = domain.get('config')
  const isMobile = config.get('isMobile')
  const isTablet = config.get('isTablet')
  const isDesktopOrWider = useMediaQuery(useMediaQueryBreakpoints.lg, {
    defaultMatches: !isMobile && !isTablet
  })

  return (
    <ModalWithUrlState
      isOpen={isOpen}
      closeOnOutsideClick
      closeOnEscKeyDown
      iconClose={<IconClose svgClass={MODAL_CLOSE_CLASS} size={ATOM_ICON_SIZES.medium} />}
      onClose={onClose}
      hash={MODAL_HASH}
      openModalTrigger={onOpen}
      className={`${BASE_CLASS}-lastAdsSearchesModal`}
      customFooter={
        !isDesktopOrWider && (
          <AtomButton
            onClick={onClose}
            size={atomButtonSizes.LARGE}
            shape={atomButtonShapes.CIRCULAR}
            design={atomButtonDesigns.FLAT}
          >
            {i18n.t('COMMON.CANCEL')}
          </AtomButton>
        )
      }
    >
      {isOpen && <TrackingWithEventTrack tracks={TRACKS} />}
      <NavigationLastAdsSearchesContent lastAdsSearches={lastAdsSearches} className={BASE_CLASS} />
    </ModalWithUrlState>
  )
}

NavigationLastAdsSearchesModal.displayName = 'NavigationLastAdsSearchesModal'
NavigationLastAdsSearchesModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
  lastAdsSearches: PropTypes.array.isRequired
}

export default NavigationLastAdsSearchesModal
